import { createApi } from '@reduxjs/toolkit/query/react';

import { ONBOARDING_API_URL } from 'api/APIBase';
import { handleError } from 'services/Error';
import { getBaseQuery } from 'store/api/apiBaseQuery';

const TagTypes = {
    SHIPPING_INFO: 'SHIPPING_INFO',
};

export const onboardingApi = createApi({
    baseQuery: getBaseQuery(ONBOARDING_API_URL),
    tagTypes: Object.values(TagTypes),
    reducerPath: 'onboardingApi',
    endpoints: (build) => ({
        postShippingInfo: build.mutation({
            query: ({ referralId, payerId, body }) => ({
                url: `admin/shipping/${referralId}`,
                params: {
                    payer_id: payerId,
                },
                method: 'POST',
                body,
            }),
            invalidatesTags: (_results, _error, { referralId }) => [
                { type: TagTypes.SHIPPING_INFO, id: referralId },
            ],
        }),
        getShippingInfo: build.query({
            query: ({ referralId }) => `admin/shipping/${referralId}`,
            providesTags: (_results, _error, { referralId }) => [
                { type: TagTypes.SHIPPING_INFO, id: referralId },
            ],
            transformErrorResponse: (err) => {
                if (err.status !== 404) {
                    handleError('An error occurred retrieving shipping information.', err);
                }
            },
        }),
        getOnboardingStatus: build.query({
            query: (referralId) => ({
                url: `admin/onboarding_status/${referralId}`,
                method: 'GET',
            }),
            transformErrorResponse: (err) => {
                if (err.status !== 404) {
                    handleError('An error occurred retrieving onboarding status.', err);
                }
            },
        }),
        getObjectiveStatuses: build.query({
            query: (referralId) => ({
                url: `admin/objective_status/${referralId}`,
                method: 'GET',
            }),
            transformErrorResponse: (err) => {
                if (err.status !== 404) {
                    handleError('An error occurred retrieving onboarding status.', err);
                }
            },
        }),
    }),
});

export const {
    usePostShippingInfoMutation,
    useGetShippingInfoQuery,
    useGetObjectiveStatusesQuery,
    useGetOnboardingStatusQuery,
} = onboardingApi;
